export default function FanaticalLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      className={className}
      fill="currentColor"
    >
      <g transform="translate(40, 40) scale(0.8)">
        <path
          fill="#FF9800"
          fillRule="evenodd"
          d="M3.231 164h285.393a3 3 0 0 0 2.723-1.742l24.972-54.04a3 3 0 0 0-2.724-4.258l-289.089.035C58.483 42.02 124.334 0 200 0c110.457 0 200 89.543 200 200s-89.543 200-200 200S0 310.457 0 200c0-12.29 1.109-24.322 3.231-36zM126 328a4 4 0 0 0 4 4h5.175l63.497-80h49.226a3 3 0 0 0 2.723-1.739l25-53.97a3 3 0 0 0-2.721-4.26L126 192z"
        />
      </g>
    </svg>
  );
}